import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import Search from '@mui/icons-material/Search';
import React from 'react';
import useConfigStyles from './useConfigStyles';
import { InputLabel } from '@mui/material';

type FilterInputProps = {
  label: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
};

function FilterInput(props: FilterInputProps): JSX.Element {
  const { value, onChange } = props;
  const classes = useConfigStyles();

  return (
    <div>
      <FormControl variant='outlined'>
        <InputLabel id="filter-admin-objects" htmlFor="outlined-adornment-amount" >Filter</InputLabel>
        <OutlinedInput
          id='outlined-adornment-amount'
          value={value}
          onChange={onChange}
          className={classes.filterInput}
          startAdornment={
            <InputAdornment position='start'>
              <IconButton disabled edge='start'>
                <Search />
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    </div>
  );
}

export default FilterInput;
